import type { ServiceList, UserServiceList } from "../shared/types.js";

export interface OnCurrentUserServiceListChanged {
  unsubscribe: () => void;
  initialUserServiceList: UserServiceList;
}

export type ServiceListSubscriber = (arg1: UserServiceList) => void;

export interface UserSettingsCookie {
  hist: ServiceList;
  sc: ServiceList;
}

export interface FavoriteServiceData {
  serviceId: string;
  favoriteServiceSource?: string;
}

export interface AddServiceIdToFavoriteServiceIdListError extends Error {
  failureSource?: string;
}

export const SERVICE_LIST_UPDATED_EVENT = "ServiceListUpdated";

export const SERVICE_LIST_ERROR_EVENT = "ServiceListError";

export const ADD_SERVICE_ID_TO_FAVORITE_SERVICE_ID_LIST_EVENT = "AddServiceIdToFavoriteServiceIdList";

export const ADD_SERVICE_ID_TO_FAVORITE_SERVICE_ID_LIST_ERROR_EVENT = "AddServiceIDToFavoriteServiceIdListError";
